let MAINTENANCE_ACTIVE = false;

export function enableMaintenance() {
  MAINTENANCE_ACTIVE = true;
}

export function disableMaintenance() {
  MAINTENANCE_ACTIVE = false;
}

export function isMaintenanceActive() {
  return MAINTENANCE_ACTIVE;
}
